import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    tvl: 'TVL',
    selfStaked: 'Self-staked',
    delegations: 'Delegations',
    delegators: 'Delegators',
    locked: 'Locked',
    unlocked: 'Unlocked',
    withdraw: 'Withdraw',
  },
};
